import { render } from "./PayModalSectionBillingData.vue?vue&type=template&id=2dd05f0e"
import script from "./PayModalSectionBillingData.vue?vue&type=script&lang=js"
export * from "./PayModalSectionBillingData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__